module.exports = __webpack_public_path__ + "arrow_right.98dd38f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/data/icons/arrow_right.svg
// module id = jfWO
// module chunks = 0